import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-200 border-t border-background-300 mt-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-white">
              <i className="ri-signal-tower-fill"></i>
            </div>
            <div className="leading-tight">
              <div className="text-[15px] font-bold text-foreground-900">スマホ代見直し案内所</div>
              <div className="text-[11px] text-foreground-500">通信費をやさしく整理</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-foreground-600 leading-7 max-w-md">
            スマホ料金、端末の買い方、修理や乗り換えの注意点を、公式情報を確認しながら整理する案内所です。
            特定の会社だけを一律にすすめるのではなく、使い方に合う選択肢を比べられる情報を掲載しています。
          </p>

          <a
            href="https://www.instagram.com/sumaho.minaoshi.guide/"
            target="_blank"
            rel="noreferrer"
            className="mt-5 inline-flex items-center gap-2.5 text-sm text-foreground-700 hover:text-primary-500"
            aria-label="スマホ代見直し案内所のInstagramを開く"
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-md bg-background-300 text-foreground-800 text-lg">
              <i className="ri-instagram-line"></i>
            </span>
            <span className="font-semibold">Instagramでやさしく解説中</span>
            <i className="ri-external-link-line text-xs"></i>
          </a>
          <p className="mt-1.5 ml-[42px] text-xs text-foreground-500">投稿では要点を、サイトでは確認手順を詳しく紹介しています</p>
        </div>

        <div>
          <div className="text-[13px] font-bold text-foreground-900 mb-3">サイト内メニュー</div>
          <ul className="space-y-2 text-sm text-foreground-700">
            <li><Link to="/bill-check" className="hover:text-primary-500 cursor-pointer">請求書チェック</Link></li>
            <li><Link to="/diagnosis" className="hover:text-primary-500 cursor-pointer">料金診断</Link></li>
            <li><Link to="/compare" className="hover:text-primary-500 cursor-pointer">通信会社を比較</Link></li>
            <li><Link to="/articles" className="hover:text-primary-500 cursor-pointer">記事一覧</Link></li>
            <li><Link to="/about" className="hover:text-primary-500 cursor-pointer">この案内所について</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[13px] font-bold text-foreground-900 mb-3">サイトポリシー</div>
          <ul className="space-y-2 text-sm text-foreground-700">
            <li><Link to="/policy" className="hover:text-primary-500 cursor-pointer">編集方針</Link></li>
            <li><Link to="/policy" className="hover:text-primary-500 cursor-pointer">免責事項</Link></li>
            <li><Link to="/privacy" className="hover:text-primary-500 cursor-pointer">プライバシーポリシー</Link></li>
            <li><Link to="/contact" className="hover:text-primary-500 cursor-pointer">お問い合わせ</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-background-300">
        <div className="mx-auto max-w-[1200px] px-4 md:px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <div className="text-xs text-foreground-500">© 2026 スマホ代見直し案内所. 掲載情報は各社公式サイトをもとに確認・更新しています。</div>
          <div className="text-xs text-foreground-500">最終更新：2026年9月23日</div>
        </div>
      </div>
    </footer>
  );
}
